var map = {
	"./mobile/blockDetail/index.vue": [
		"4870",
		"chunk-793d4533",
		"chunk-3846b57a",
		"chunk-0154d2d6",
		"chunk-a0103c92",
		"chunk-0d0ff44f"
	],
	"./pc/blockDetail/index.vue": [
		"b26a",
		"chunk-793d4533",
		"chunk-3846b57a",
		"chunk-0154d2d6",
		"chunk-a0103c92",
		"chunk-5d7e0a08"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2b22";
module.exports = webpackAsyncContext;